var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass: "d-none d-md-none d-lg-block",
      class: this.sidemenu_minimized,
      attrs: { id: "sidebar" }
    },
    [
      _c("div", { staticClass: "sidebar-header" }, [
        _c(
          "div",
          {
            staticStyle: { "margin-top": "65px", "margin-left": "5px" },
            on: {
              click: function($event) {
                return _vm.toggleToIcons()
              }
            }
          },
          [
            _c("i", { staticClass: "fa fa-bars fa-1x" }),
            _vm._v(" "),
            _c("span", { staticClass: "menu-item-name app-heading" }, [
              _vm._v("Mentoring")
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "list-unstyled" }, [
        _c(
          "li",
          { staticClass: "active" },
          [
            _c("router-link", { attrs: { to: _vm.url } }, [
              _c("i", { staticClass: "fa fa-home" }),
              _vm._v(" "),
              _c("span", { staticClass: "menu-item-name" }, [_vm._v("Home")])
            ])
          ],
          1
        ),
        _vm._v(" "),
        _vm.$store.state.school_flag === true ||
        _vm.$store.state.switch_admin_account_flag === true
          ? _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/add-instructor" } }, [
                  _c("i", { staticClass: "fa fa-user-plus" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "menu-item-name" }, [
                    _vm._v("Add Instructor")
                  ])
                ])
              ],
              1
            )
          : _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/add-mentor" } }, [
                  _c("i", { staticClass: "fa fa-user-plus" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "menu-item-name" }, [
                    _vm._v("Add Mentor")
                  ])
                ])
              ],
              1
            ),
        _vm._v(" "),
        _vm.$store.state.school_flag === true ||
        _vm.$store.state.switch_admin_account_flag === true
          ? _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/add-student" } }, [
                  _c("i", { staticClass: "fa fa-child" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "menu-item-name" }, [
                    _vm._v("Add Student")
                  ])
                ])
              ],
              1
            )
          : _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/add-mentee" } }, [
                  _c("i", { staticClass: "fa fa-child" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "menu-item-name" }, [
                    _vm._v("Add Mentee")
                  ])
                ])
              ],
              1
            ),
        _vm._v(" "),
        _vm.$store.state.school_flag != true ||
        _vm.$store.state.switch_admin_account_flag != true
          ? _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/add-apprentice" } }, [
                  _c("i", { staticClass: "fa fa-child" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "menu-item-name" }, [
                    _vm._v("Add Apprentice")
                  ])
                ])
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.$store.state.school_flag === true ||
        _vm.$store.state.switch_admin_account_flag === true
          ? _c(
              "li",
              [
                _c("router-link", { attrs: { to: "/add-group" } }, [
                  _c("i", { staticClass: "fa fa-users" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "menu-item-name" }, [
                    _vm._v("Add Group")
                  ])
                ])
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "list-unstyled list-signout-menu" }, [
        _c(
          "li",
          [
            _c("router-link", { attrs: { to: "/logout" } }, [
              _c("i", { staticClass: "fa fa-sign-out" }),
              _vm._v(" "),
              _c("span", { staticClass: "menu-item-name" }, [
                _vm._v("Sign Out")
              ])
            ])
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68b00f5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68b00f5c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/admin_sidebar_menu.vue
// module id = null
// module chunks = 